import {
  ICustomReportChart,
  ICustomReportData,
  ReportingReference,
} from '@principle-theorem/principle-core/interfaces';
import { titlecase } from '@principle-theorem/shared';
import { compact, first, kebabCase, uniq } from 'lodash';

export class ReportBuilderHelpers {
  static getSectionFromPrefix(
    id: string,
    noSection?: string
  ): string | undefined {
    const segments = id.split('.');
    const section = segments.length > 1 ? first(segments) : undefined;
    const result = section ?? noSection;
    if (!result) {
      return;
    }
    return titlecase(kebabCase(result).replace(/-/g, ' '));
  }

  static getDatapoints(data: ICustomReportData): ReportingReference[] {
    const columnDatapoints = data.columns?.map((column) => column.id);
    const filterDatapoints = data.staticFilters?.map((filter) => filter.id);
    const chartDatapoints = data.chartSections?.flatMap((section) =>
      section.charts.flatMap((chart) => this.getDatapointsForChart(chart))
    );
    return uniq(
      compact([filterDatapoints, columnDatapoints, chartDatapoints].flat())
    );
  }

  static getDatapointsForChart(
    chart: ICustomReportChart
  ): ReportingReference[] {
    return [
      chart.groupBy,
      ...chart.settings.map((setting) => setting.dataPoint),
    ];
  }

  static hasRequiredDatapoints(
    current: ReportingReference[],
    requested: ReportingReference[]
  ): boolean {
    return requested.every((datapoint) => current.includes(datapoint));
  }
}
